import React, { useState, memo, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { isValidPhoneNumber } from "react-phone-number-input";
import CommonPhoneInputs from "../../shared/authinput/CommonPhoneInputs";
import {
  DetailFormMain,
  UserAvatar,
  CameraButton,
  UserAvatarMian,
  DetailHeader,
  UserInfo,
  FormPart,
} from "../customer/styles/DetailFormStyles";
// import CameraAltIcon from "@mui/icons-material/CameraAlt";
import AuthInput from "../../shared/authinput";
import MainButton from "../../shared/Button";
// import orderimg from "../../../assets/images/orderimg.png";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../shared/commonstyle/PhoneStyle";
import { UpdateCustomerStatus } from "../../../services/admin/customer";
import { toast } from "react-hot-toast";
import { validationSchema } from "../../../helpers/validations/admin/PersonalDetails";

const PersonalDetailsForm = ({ data = {} }) => {
  const [activeloading, setactiveLoading] = useState(false);
  const [userStatus, setuserStatus] = useState(null);
  const [inactiveloading, setinactiveLoading] = useState(false);
  // const [userImage, setuserImage] = useState(false);
  // const [ImageUrl, setImageUrl] = useState(orderimg);
  const userName = data?.name || "";
  const initials = userName
    .split(" ")
    .map((name) => name.charAt(0))
    .join("");

  useEffect(() => {
    if (data?.status) {
      setuserStatus(data?.status);
    }
  }, [data?.status]);

  // const handleImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setuserImage(reader);
  //       setImageUrl(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleChange = (value, event, form) => {
    // SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }
    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };
  const handleSubmit = (values) => {
    console.log("values", values);
  };

  const initialValues = {
    CompanyName: data?.company_name || "",
    FirstName: data?.name || "",
    email: data?.email || "",
    phoneNumber: data?.phone_number ? "+" + data?.phone_number : "",
    Location: data?.location?.address || "",
  };

  const HandelApproveUser = async () => {
    const res = await UpdateCustomerStatus(
      setactiveLoading,
      data?.slug,
      "active",
      "drivers"
    );
    if (res.status === 200) {
      toast.success("Updated successfully");
      setuserStatus("active");
    }
  };
  const HandelRejectUser = async () => {
    const res = await UpdateCustomerStatus(
      setinactiveLoading,
      data?.slug,
      "inactive",
      "drivers"
    );
    if (res.status === 200) {
      toast.success("Updated successfully");
      setuserStatus("inactive");
    }
  };

  return (
    <>
      {data?.status && (
        <DetailFormMain changeWidth={true}>
          <DetailHeader>
            <UserAvatarMian>
              {data?.profile_image_url ? (
                <UserAvatar alt="user image" src={data?.profile_image_url} />
              ) : (
                <UserAvatar alt={userName}>{initials}</UserAvatar>
              )}
              {/* <CameraButton component="label" htmlFor="avatar-upload">
                <CameraAltIcon />
                <input
                  id="avatar-upload"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />
              </CameraButton> */}
            </UserAvatarMian>
            <UserInfo>
              <h6>{data?.name || ""}</h6>
              <p>{data?.phone_number ? "+" + data?.phone_number : ""}</p>
            </UserInfo>
          </DetailHeader>
          <FormPart>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="CompanyName"
                      label="Company Name"
                      component={AuthInput}
                      placeholder="Enter your Company Name"
                      disabled
                    />
                    <Field
                      type="text"
                      name="FirstName"
                      label="First Name"
                      component={AuthInput}
                      placeholder="Enter your First Name"
                      disabled
                    />
                  </div>
                  <div className="FormItem havePhone">
                    <PhoneInputsMain
                      className={`PhoneInputsMain ${
                        formik.touched.phoneNumber &&
                        formik.errors.phoneNumber &&
                        "is__error"
                      }`}
                    >
                      <CustomLabel>Phone Number</CustomLabel>
                      <Field name="phoneNumber">
                        {({ field, form }) => (
                          <CommonPhoneInputs
                            {...field}
                            onChange={(value, event) =>
                              handleChange(value, event, form)
                            }
                            isDisable={true}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="phoneNumber"
                        component="span"
                        className="error"
                      />
                    </PhoneInputsMain>
                    <Field
                      type="email"
                      name="email"
                      label="Email Address"
                      component={AuthInput}
                      placeholder="Enter your Email Address"
                      disabled
                    />
                  </div>
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="Location"
                      label="Address / Location"
                      component={AuthInput}
                      placeholder="Address / Location"
                      disabled
                    />
                  </div>
                  {userStatus && (
                    <div className="ButtonMain">
                      {userStatus === "pending" && (
                        <>
                          <MainButton
                            type="button"
                            label="Approve"
                            MT="80"
                            onClick={HandelApproveUser}
                            isLoading={activeloading}
                          />
                          <MainButton
                            type="button"
                            label="Reject"
                            MT="80"
                            border={true}
                            onClick={HandelRejectUser}
                            isLoading={inactiveloading}
                          />
                        </>
                      )}
                      {userStatus === "inactive" && (
                        <MainButton
                          type="button"
                          label="Approve"
                          MT="80"
                          onClick={HandelApproveUser}
                          isLoading={activeloading}
                        />
                      )}
                      {userStatus === "active" && (
                        <MainButton
                          type="button"
                          label="Reject"
                          MT="80"
                          border={true}
                          onClick={HandelRejectUser}
                          isLoading={inactiveloading}
                        />
                      )}
                    </div>
                  )}
                  {/* <div className="ButtonMain">
                    <MainButton type="button" label="Approve" MT="80" />
                    <MainButton
                      type="button"
                      label="Reject"
                      MT="80"
                      border={true}
                    />
                  </div> */}
                </Form>
              )}
            </Formik>
          </FormPart>
        </DetailFormMain>
      )}
    </>
  );
};

export default memo(PersonalDetailsForm);
